import TemplateView from '../../TemplateView'
import Button from '../../components/Button'
import messageResource from '../../messageResource'
import {getBrowser} from '../../atBrowserUtils'
import {Browser} from '../../constants'
import CookiesInstruction from './CookiesInstruction'

export default class CookiesDisabledLoginPlug extends TemplateView {
    constructor({} = {}) {
        super()

        this.state = {
            collapsed: true,
        }

        this.onStatePropertyChanged('collapsed', (collapsed) => {
            this.$enableCookiesBlock.toggleClass('collapsed', collapsed)
        })
    }

    templateHtml() {
        return '<div class="cookiesDisabledLoginPlug">' +
               '    <div class="title"><%=title%></div>' +
               '    <div class="content">' +
               '        <div class="paragraph"><%=paragraph1%></div>' +
               '        <div class="paragraph"><%=paragraph2%></div>' +
               '        <div class="enableCookiesBlock">' +
               '                <div class="collapsibleHeader">' +
               '                    <div class="icon"/>' +
               '                    <div class="text"><%=instructionTitle%></div>' +
               '                </div>' +
               '                <div class="instructionPlaceholder"/>' +
               '                <div class="browserSupportSection">' +
               '                    <div class="cookie"/>' +
               '                    <div class="text"/>' +
               '                </div>' +
               '        </div>' +
               '        <div class="paragraph"><%=paragraph3%></div>' +
               '    </div>' +
               '    <div class="updateButton"/>' +
               '</div>'
    }

    messageKeys() {
        return {
            title: 'login.cookies_disabled.title',
            paragraph1: 'login.cookies_disabled.paragraph1',
            paragraph2: 'login.cookies_disabled.paragraph2',
            paragraph3: 'login.cookies_disabled.paragraph3',
            instructionTitle: 'login.cookies_disabled.instruction_title',
        }
    }

    afterRender() {
        this.$enableCookiesBlock = this.find('.enableCookiesBlock')
        new Button({
            onClickCb: () => {document.location.reload()},
            label: messageResource.getMessage('login.cookies_disabled.update'),
        }).init(this.find('.updateButton'))

        const browser = getBrowser()
        this.find('.browserSupportSection .text').html(this.getBrowserSupportText(browser))
        new CookiesInstruction({
            browser,
        }).init(this.find('.instructionPlaceholder'))
        this.find('.collapsibleHeader').on('click', () => this.setState({collapsed: !this.state.collapsed}))
        this.renderInitialState()
    }

    getBrowserSupportText(browser) {
        const browserToTextMap = {
            [Browser.CHROME]: messageResource.getMessage('login.cookies_disabled.browser_support.chrome',
                ['https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=en&oco=0']),
            [Browser.SAFARI]: messageResource.getMessage('login.cookies_disabled.browser_support.safari',
                ['https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac']),
            [Browser.EDGE]: messageResource.getMessage('login.cookies_disabled.browser_support.edge',
                ['https://support.microsoft.com/search/results?query=enable+cookies+Microsoft+Edge&isEnrichedQuery=true']),
            [Browser.IE]: messageResource.getMessage('login.cookies_disabled.browser_support.ie',
                ['https://support.microsoft.com/en-us/topic/change-security-and-privacy-settings-for-internet-explorer-11-9528b011-664c-b771-d757-43a2b78b2afe']),
            [Browser.FIREFOX]: messageResource.getMessage('login.cookies_disabled.browser_support.firefox',
                ['https://support.mozilla.org/en-US/kb/websites-say-cookies-are-blocked-unblock-them']),
            [Browser.OPERA]: messageResource.getMessage('login.cookies_disabled.browser_support.opera',
                ['https://help.opera.com/en/latest/web-preferences/#cookies']),
            [Browser.OTHER]: messageResource.getMessage('login.cookies_disabled.browser_support.other'),
        }

        return browserToTextMap[browser]
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/login/CookiesDisabledLoginPlug.js